import { useWatchfaceDevices, WatchfaceDeviceType } from '@/hooks';
import { Shape, ShapeType } from '@/services/shape';
import { canUse } from '../can-use.utils';
import { Description } from '@/types/watchface';

const _getInvalidTypesInAod = (deviceType: WatchfaceDeviceType) => {
  const _types: ShapeType[] = [
    ShapeType.JsFile,
    ShapeType.Sprite,
    ShapeType.PhotoAlbumBg,
    ShapeType.Rive,
    ShapeType.TextWatchface,
    ShapeType.VideoWatchface,
    ShapeType.ApkFile
  ];
  if (!canUse('aod-shape-app-widget').valid) {
    _types.push(ShapeType.AppWidget)
  }
  if (deviceType == 'M66') {
    _types.push(ShapeType.Slot, ShapeType.Widget);
  }
  return _types;
};

/**
 *  验证图层是否可用在息屏下
 * @param shapeType
 * @returns
 */
export const canUseInAOD = (
  deviceType: WatchfaceDeviceType,
  shapeType: ShapeType
) => {
  const disabledShapesInAOD = _getInvalidTypesInAod(deviceType);
  return disabledShapesInAOD.includes(shapeType) ? false : true;
};

/**
 * 验证图层是否可用
 * @param shape
 * @param deviceType
 * @returns
 */
export const validShapeEnabled = (data: {
  shape: Shape;
  deviceType: WatchfaceDeviceType;
  watchOS: Description['watchOS'];
  themeType: StoreThemeItem['type'];
}) => {
  const { shape, deviceType, watchOS, themeType } = data;
  const { type: shapeType, attrs } = shape;

  let valid = true;

  const deviceInfo = useWatchfaceDevices().findDeivce(deviceType);

  switch (shapeType) {
    case ShapeType.Text:
      valid = canUse('shape-text', deviceType).valid;
      break;
    case ShapeType.Sprite:
      valid =
        (attrs.spriteType ?? 'sprite') == 'sprite'
          ? canUse('shape-sprite', deviceType).valid
          : canUse('shape-video', deviceType).valid;
      break;
    case ShapeType.ProgressBar:
      valid = canUse('shape-progress-bar', deviceType).valid;
      break;
    case ShapeType.JsFile:
      valid = canUse('shape-js-lua', deviceType).valid;
      break;
    case ShapeType.TextWatchface:
      valid = canUse('text-watchface', deviceType).valid;
      break;
    case ShapeType.Rive:
      valid = canUse('rive', deviceType).valid;
      break;
    case ShapeType.ApkFile:
      valid = canUse('shape-apk', deviceType).valid;
      break;
    case ShapeType.VideoWatchface:
      valid = canUse('video-watchface', deviceType).valid;
      // 在为真的情况下进一步判断
      if (valid && deviceInfo?.watchOS == 'android' && watchOS != 'android') {
        valid = false;
      }
      break;

    case ShapeType.Slot:
      valid = canUse('shape-slot', deviceType).valid;
      break;
    default:
      break;
  }
  // 判断息屏下的支持情况
  if (themeType == 'AOD' && !canUseInAOD(deviceType, shapeType)) {
    valid = false;
  }
  return valid;
};
